import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import PharoLayout from 'layout/PharoLayout';
import PagesLayout from 'layout/Pages';
import ConditionalRoute from 'components/ConditionalRoute';
import AdminRoute from 'components/AdminRoute';
import RiskToolsRoute from 'components/RiskToolsRoute';
import ComplianceRoute from 'components/ComplianceRoute';
import DefaultRoute from 'components/DefaultRoute';

const OrdersPage = Loadable(lazy(() => import('pages/pharo/Orders')));
const OrderCreateEditPage = Loadable(lazy(() => import('pages/pharo/OrderCreateEdit')));
const OpsTool1Page = Loadable(lazy(() => import('pages/pharo/OpsTool1')));
const OpsTool2Page = Loadable(lazy(() => import('pages/pharo/OpsTool2')));
const AdminPage = Loadable(lazy(() => import('pages/pharo/Admin')));
const PmMandatesToolsPage = Loadable(lazy(() => import('pages/pharo/PmMandatesTools')));
const ErrorPage = Loadable(lazy(() => import('sections/pharo/ErrorPage')));
const CompliancePage = Loadable(lazy(() => import('pages/pharo/Compliance')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    // Default route - redirects based on user role
    {
      path: '/',
      element: <PharoLayout />,
      children: [
        {
          path: '',
          element: <DefaultRoute />
        }
      ]
    },
    // Order Management Routes (hidden for Ops users)
    {
      path: '/',
      element: <PharoLayout />,
      children: [
        {
          path: 'orders',
          element: (
            <ConditionalRoute requireOrderManagement={true}>
              <OrdersPage />
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        }
      ]
    },
    {
      path: '/',
      element: <PharoLayout />,
      children: [
        {
          path: 'order-create',
          element: (
            <ConditionalRoute requireOrderManagement={true}>
              <OrderCreateEditPage key='create' />
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        }
      ]
    },
    {
      path: '/',
      element: <PharoLayout />,
      children: [
        {
          path: 'order-edit',
          element: (
            <ConditionalRoute requireOrderManagement={true}>
              <OrderCreateEditPage />
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        }
      ]
    },
    {
      path: '/',
      element: <PharoLayout />,
      children: [
        {
          path: 'template',
          element: (
            <ConditionalRoute requireOrderManagement={true}>
              <OrderCreateEditPage />
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        }
      ]
    },
    // Operations Tools Routes (nested structure)
    {
      path: '/',
      element: <PharoLayout />,
      children: [
        {
          path: 'ops-tools',
          element: (
            <ConditionalRoute requireOpsTools={true}>
              <OpsTool1Page />
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        },
        {
          path: 'ops-tools/tool-1',
          element: (
            <ConditionalRoute requireOpsTools={true}>
              <OpsTool1Page />
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        },
        {
          path: 'ops-tools/tool-2',
          element: (
            <ConditionalRoute requireOpsTools={true}>
              <OpsTool2Page />
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        },
        {
          path: 'ops-tools/tool-3',
          element: (
            <ConditionalRoute requireOpsTools={true}>
              <div style={{ padding: '20px' }}>
                <h2>Ops Tool 3 - Reconciliation</h2>
                <p>This tool is under development.</p>
              </div>
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        },
        {
          path: 'ops-tools/tool-4',
          element: (
            <ConditionalRoute requireOpsTools={true}>
              <div style={{ padding: '20px' }}>
                <h2>Ops Tool 4 - Risk Monitoring</h2>
                <p>This tool is under development.</p>
              </div>
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        },
        {
          path: 'ops-tools/tool-5',
          element: (
            <ConditionalRoute requireOpsTools={true}>
              <div style={{ padding: '20px' }}>
                <h2>Ops Tool 5 - Reporting</h2>
                <p>This tool is under development.</p>
              </div>
            </ConditionalRoute>
          ),
          errorElement: <ErrorPage />
        }
      ]
    },
    // Analytics Route (admin only)
    {
      path: '/',
      element: <PharoLayout />,
      children: [
        {
          path: 'admin',
          element: (
            <AdminRoute showAccessDenied={true}>
              <AdminPage />
            </AdminRoute>
          ),
          errorElement: <ErrorPage />
        },
        {
          path: 'pm-mandates',
          element: (
            <RiskToolsRoute showAccessDenied={true}>
              <PmMandatesToolsPage />
            </RiskToolsRoute>
          ),
          errorElement: <ErrorPage />
        },
        // Compliance alert snooze module (compliance and admin only)
        {
          path: 'compliance',
          element: (
            <ComplianceRoute showAccessDenied={true}>
              <CompliancePage />
            </ComplianceRoute>
          ),
          errorElement: <ErrorPage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    }    
  ]
};

export default MainRoutes;
